import React from 'react';
import PropTypes from 'prop-types';

const SelectSwitch = ({ className, name, value, onChange, disabled }) => {

  const handleChange = (event) => {
    const { name, value } = event.target;
    onChange(name, value === 'true');
  };


  return <select className={className ?? 'form-select border-0'} name={name} value={value ? 'true' : 'false'} disabled={disabled} onChange={handleChange}>
    <option value="true">True</option>
    <option value="false">False</option>
  </select>;
}

export default SelectSwitch;

SelectSwitch.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  value: PropTypes.bool.isRequired,
  onChange: PropTypes.func,
  disabled: PropTypes.bool.isRequired
}
